import { DataGridPremium, GridColDef, GridRenderCellParams, GridValueGetterParams, useGridApiRef } from '@mui/x-data-grid-premium';
import { Status } from '../../hooks/useFetch';
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import { USERFEEDBACK } from '../../common/paths';
import { UserFeedback } from '@aviation/cabinapp-userfeedbackservice-sdk';

export interface IUserFeedbackListGridProps {
    data?: UserFeedback[];
    status: Status;
}

function UserFeedbackListGrid(props: IUserFeedbackListGridProps) {
    const apiRef = useGridApiRef();
    const location = useLocation();
    const { status, data = [] } = props;

    const rowId = (row: UserFeedback) => {
        return row.Id;
    }
    const rows = useMemo(() => {
        const result = data?.map(o => { return {
            ...o,
            id: rowId(o),
        }}) ?? [];
        return result.sort((a, b) => (a.InsertedOn ?? '') < (b.InsertedOn ?? '') ? 1 : -1);
    }, [data]);

    const navigateTo = (row: UserFeedback) => {
        const gridState = apiRef.current.exportState();
        localStorage.setItem(`GRID_${location.pathname}`, JSON.stringify(gridState));
        window.open(`/${USERFEEDBACK}/${encodeURIComponent(row.Id ?? '')}`, '_blank');
    }

    const columns: GridColDef[] = [
        { field: 'LtrCode', headerName: '3LC', minWidth: 50 },
        { field: 'ClientCode', headerName: 'Airline', minWidth: 70 },
        { field: 'AppVer', headerName: 'Version', minWidth: 70 },
        { field: 'Type', headerName: 'Type', minWidth: 70 },
        { field: 'Content', headerName: 'Content', minWidth: 250, flex: 1 },
        { field: 'InsertedOn', headerName: 'Inserted on', minWidth: 120, renderCell: (params: GridRenderCellParams<Date>) => params.value === undefined ? '' : dayjs(params.value).format('DD.MM.YYYY HH:mm') },
        { field: 'Files', headerName: 'Files', minWidth: 80, type: 'number', valueGetter: (params: GridValueGetterParams) => params.row.Files?.length ?? 0 },
    ];

    return (
        <DataGridPremium
            apiRef={apiRef}
            autoHeight
            rows={rows}
            columns={columns}
            editMode='row'
            isCellEditable={() => false}
            rowSelection={true}
            getRowClassName={(params) => { return params.indexRelativeToCurrentPage % 2 === 1 ? `tui-grid-alternate-row` : '' }}
            pagination
            loading={status === Status.Fetching || status === Status.Idle}
            onRowClick={(params) => navigateTo(params.row)}
            sx={{ cursor: 'pointer' }}
        />
    );
}

export default UserFeedbackListGrid;
